import { render, staticRenderFns } from "./Etape2.vue?vue&type=template&id=6079f563&scoped=true&"
import script from "./Etape2.vue?vue&type=script&lang=js&"
export * from "./Etape2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6079f563",
  null
  
)

export default component.exports